/** Days left until `expiresAt` (unix seconds), floored at 0. Used for trial and cancellation banners. */
export function daysRemaining(expiresAt: number | null): number {
  if (!expiresAt) return 0;
  return Math.max(0, Math.ceil((expiresAt * 1000 - Date.now()) / (24 * 60 * 60 * 1000)));
}
